import React, {Component} from 'react';
import PictographsElectricityController from './PictographsElectricityController'
import PictographsWaterController from './PictographsWaterController'
import PictographsGasController from './PictographsGasController'



export default class PictographsView extends Component {
  constructor(props){
    super(props)
  }

  render() {
    return (
      <div className="graph-container">
        <h3 className="graph-header">This Month You Used</h3>
       
        <PictographsWaterController uiConfig={this.uiConfig} signedIn={this.props.signedIn} user={this.props.user}/>
        <PictographsElectricityController uiConfig={this.uiConfig} signedIn={this.props.signedIn} user={this.props.user}/>
        <PictographsGasController uiConfig={this.uiConfig} signedIn={this.props.signedIn} user={this.props.user}/>

      </div>
    )
  }
}